'use strict';

var React = require('react'),
    createStoreMixin = require('../mixins/createStoreMixin'),
    StampDraftStore = require('../stores/StampDraftStore'),
    UserStore = require('../stores/UserStore'),
    ScreenSizeMixin = require('../mixins/ScreenSizeMixin'),
    MetaList = require('../molecules/MetaList'),
    UserInfo = require('../organisms/UserInfo'),
    shallowEqual = require('react/lib/shallowEqual'),
    formatDate = require('../utils/formatDate'),
    PureRenderMixin = require('../mixins/PureRenderMixin');

var DraftPreviewNavHeader = React.createClass({
  mixins: [createStoreMixin(StampDraftStore, UserStore), ScreenSizeMixin, PureRenderMixin],

  getStateFromStores() {
    const draft = StampDraftStore.getDraftStamp();
    let user;

    if (draft) {
      user = UserStore.get(draft.user);
    }

    return { draft, user };
  },

  componentWillReceiveProps(nextProps) {
    if (!shallowEqual(nextProps, this.props)) {
      this.setState(this.getStateFromStores(nextProps));
    }
  },

  render() {
    const { draft, user, isMobile } = this.state;
    if (!draft || !user) {
      return null;
    }

    const published = draft.published ? new Date(draft.published) : new Date();

    return (
      <MetaList context='NavBar'
                inline={!isMobile}
                separated={!isMobile}>
        <UserInfo user={user}
                  context='NavBar'
                  imageSize='small'
                  size='xsmall'>
          <span>
            {' on '}{formatDate(published)}
          </span>
        </UserInfo>
      </MetaList>
    );
  }
});

module.exports = DraftPreviewNavHeader;



/** WEBPACK FOOTER **
 ** ./molecules/DraftPreviewNavHeader.jsx
 **/